import React from "react";

//Bootstrap
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Knowledge = () => {
	return (
		<React.Fragment>
			<div className="row row-even">
				<div className="inside-row-div">
					<Container>
						<div className="knowledge-content ">
							<Row>
								<Col>
									<h3>Languages and Frameworks</h3>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670016477/portfolio/Java_logo_lbmnvc.png"
												alt="Java programming language logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Java
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670685507/portfolio/1_O68LbDvD5Dcsnez73M7v4Q_jatp7v.png"
												alt="Spring Boot logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Spring Boot
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1589745201/portfolio/58482ce4cef1014c0b5e4a4c_xuguox.png"
												alt="Swift programming language logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Swift
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670685309/portfolio/angular-icon-logo_bvpvis.png"
												alt="Angular logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Angular
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670685961/portfolio/vue-logo_gmerjv.png"
												alt="Vue JS logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Vue.js
										</h5>
									</div>
								</Col>

								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<div className="react-logo">
												<div className="nucleo"></div>
											</div>
										</div>
										<h5 className="knowledge-item-title">
											React
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1583979993/portfolio/html_jqmdao.png"
												alt="HTML programming language logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											HTML
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1583979993/portfolio/css_bzott5.png"
												alt="CSS programming language logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											CSS
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1583979993/portfolio/js_wfxwvm.png"
												alt="JavaScript programming language logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											JavaScript
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670686205/portfolio/Typescript_logo_2020.svg_ybkg67.png"
												alt="TypeScript programming language logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											TypeScript
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<p className="ejs-logo-text">EJS</p>
										</div>
										<h5 className="knowledge-item-title">
											Embeded JavaScript
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<p className="express-logo-text">
												express
											</p>
										</div>
										<h5 className="knowledge-item-title">
											express.js
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<p className="express-logo-text">
												SQL
											</p>
										</div>
										<h5 className="knowledge-item-title">
											Relational Databases
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<h3>Platforms and Environments</h3>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1583983273/portfolio/nodejs-logo-png-node-js-on-dark-background-1843_hqynup.png"
												alt="Node.js logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											node.js
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1583983303/portfolio/mongodb-logo-white_anvha0.png"
												alt="mongoDB logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											mongoDB
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1613166047/portfolio/heroku-5-569467_nyhbth.png"
												alt="Heroku logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Heroku
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1613166046/portfolio/google_firebase-2-512_mztohl.png"
												alt="Firebase logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Firebase
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<h3>DevOps</h3>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670688152/portfolio/gitlab-logo-png-transparent_k4ud7n.png"
												alt="GitLab logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											GitLab
										</h5>
									</div>
								</Col>
                <Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670688259/portfolio/1200px-Jenkins_logo.svg_bc9ifg.png"
												alt="Jenkins Pipeline Log"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Jenkins
										</h5>
									</div>
								</Col>
                <Col>
									<div className="knowledge-item knowledge-normal">
										<div className="knowledge-logo-container">
											<img
												src="https://res.cloudinary.com/hbmteb7ks/image/upload/v1670688326/portfolio/Moby-logo-sm_frc9nr.webp"
												alt="Docker Containers Software Logo"
											></img>
										</div>
										<h5 className="knowledge-item-title">
											Docker
										</h5>
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<h3>Libraries</h3>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="knowledge-item knowledge-mini">
										<h5 className="library-name">
											Bootstrap
										</h5>
									</div>
								</Col>
								<Col>
									<div className="knowledge-item knowledge-mini">
										<h5 className="library-name">jQuery</h5>
									</div>
								</Col>
							</Row>
						</div>
					</Container>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Knowledge;
